import { createSlice } from '@reduxjs/toolkit';

import { HIDE_ALERT, SHOW_ALERT } from './actionTypes';
import { NAME } from './constants';
const INITIAL_STATE = {
    alert: {
        cancelText: '',
        confirmText: '',
        defaultTextResponse: '',
        haveTextCaptcha: false,
        haveTextResponse: false,
        hideButtons: false,
        messages: [],
        onSuccess: null,
        textToValidate: '',
        title: null,
        type: 'confirm',
    },
    isOpen: false,
};

const alertsSlice = createSlice({
    name: NAME,
    initialState: INITIAL_STATE,
    reducers: {
        [HIDE_ALERT]: (state) => {
            state.isOpen = false;
        },
        [SHOW_ALERT]: (state, action) => {
            state.alert = { ...state.alert, ...action.payload };
            state.isOpen = true;
        },
    },
});

export const alertsActions = alertsSlice.actions;

export default alertsSlice.reducer;
